module.exports = __webpack_public_path__ + "static/media/MarneEnseignes.a5b3aaff.png";